// Brand asterisk: three rounded bars crossing at the centre.
// `rotation` turns the whole mark — 90 gives the upright sidebar mark, 0 the auth backdrop.
export default function AsteriskMark({ rotation = 90, ...props }) {
  return (
    <svg viewBox="0 0 100 100" fill="currentColor" aria-hidden="true" {...props}>
      <g transform={`rotate(${rotation} 50 50)`}>
        {[0, 60, 120].map((angle) => (
          <rect
            key={angle}
            x="2"
            y="36"
            width="96"
            height="28"
            rx="8"
            transform={`rotate(${angle} 50 50)`}
          />
        ))}
      </g>
    </svg>
  );
}
